export enum ListLayoutViewType {
    Table = 'table',
    Kanban = 'kanban',
    Timeline = 'timeline',
    Calendar = 'calendar',
}

export interface ListLayoutConfig {
    enabledViews: ListLayoutViewType[];
    defaultView: ListLayoutViewType;
    enableFilters: boolean;
    enableExports: boolean;
    enableSavedFilters: boolean;
    storageKey: string;
}

export interface TableColumn {
    text: string;
    value: string;
    type: 'text' | 'number' | 'date' | 'datetime' | 'boolean' | 'select' | 'custom';
    sortable?: boolean;
    filterable?: boolean;
    width?: string | number;
    align?: 'left' | 'center' | 'right';
    required?: boolean;
    readonly?: boolean;
    suffix?: string;
    valueText?: string;
}

export interface TableConfig {
    columns: TableColumn[];
    serverSidePagination: boolean;
    pageSize: number;
    pageSizeOptions?: number[];
    sortable: boolean;
    selectable: boolean;
    defaultSort?: {
        column: string;
        direction: 'asc' | 'desc';
    };
}

export interface KanbanColumn {
    name: string;
    propertyValue: string | number | boolean;
    color?: string;
    icon?: string;
    collapsible?: boolean;
}

export interface KanbanConfig {
    groupByProperty: string;
    columns: KanbanColumn[];
    cardTemplate?: string;
    enableDragDrop: boolean;
    cardHeight?: number;
    swimlanes?: boolean;
}

export interface TimelineSegmentType {
    type: string;
    label: string;
    color: string;
}

export interface TimelineConfig {
    startDateProperty: string;
    endDateProperty: string;
    groupByProperty?: string;
    labelProperty?: string;
    rowHeight: number;
    segmentTypes: TimelineSegmentType[];
    enableZoom?: boolean;
    minZoom?: number;
    maxZoom?: number;
}

export interface CalendarConfig {
    dateProperty: string;
    startTimeProperty?: string;
    endTimeProperty?: string;
    titleProperty: string;
    colorProperty?: string;
    viewMode: 'month' | 'week' | 'day';
    enableDragDrop?: boolean;
    weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
}

export interface FilterOption {
    text: string;
    value: string | number | boolean;
}

export interface FilterDefinition {
    id: string;
    label: string;
    type: 'text' | 'select' | 'date' | 'daterange' | 'number' | 'boolean' | 'multiselect';
    property: string;
    options?: FilterOption[];
    defaultValue?: any;
    placeholder?: string;
    visible?: boolean;
    advanced?: boolean;
}

export interface SavedFilter {
    id: string;
    name: string;
    filters: Record<string, any>;
    isDefault: boolean;
    createdAt: Date;
    updatedAt?: Date;
}

export interface ListLayoutState {
    activeView: ListLayoutViewType;
    filters: Record<string, any>;
    savedFilters: SavedFilter[];
    tableState: TableState;
    kanbanState: KanbanState;
    showFilters: boolean;
}

export interface TableState {
    sort?: {
        column: string;
        direction: 'asc' | 'desc';
    };
    pageSize: number;
    currentPage: number;
    selectedItems: string[];
}

export interface KanbanState {
    collapsedColumns: string[];
}

export interface PaginationData {
    total: number;
    skip: number;
    take: number;
    currentPage: number;
    totalPages: number;
}

export interface ExportOptions {
    format: 'xlsx' | 'csv' | 'pdf';
    fileName?: string;
    includeFilters?: boolean;
}

export interface ListLayoutDataQuery {
    skip?: number;
    take?: number;
    filters?: Record<string, any>;
    sort?: {
        column: string;
        direction: 'asc' | 'desc';
    };
}
